import './SortByFilter.scss';
import { getDirectParent } from '@lib/popups';
import { SanitizedHtml } from '@ui/general';
import { When } from 'react-if';
import { DownOutlined, SortAscendingOutlined, SortDescendingOutlined } from '@ant-design/icons';
import { Dropdown, Tooltip } from 'antd';
import React, { memo, useCallback } from 'react';
import { SonarV3SortDirection } from '@sonar-software/sonar-ts-types';
export const SortByFilter = memo(({ defaultSortOption, onChange, queryParams, options, sortIcon }) => {
    var _a, _b, _c;
    const sortBy = (_a = queryParams.sortBy) !== null && _a !== void 0 ? _a : defaultSortOption.key;
    const sortDir = (_b = queryParams.sortDirection) !== null && _b !== void 0 ? _b : defaultSortOption.direction;
    const currentSortBy = (_c = options.find((option) => option.key === sortBy)) === null || _c === void 0 ? void 0 : _c.label;
    const sortText = `Sorted by: ${currentSortBy}`;
    const updateFilter = useCallback((sort) => {
        if (sort.key !== sortBy || sort.direction !== sortDir) {
            onChange({
                sortBy: sort.key,
                sortDirection: sort.direction
            });
        }
    }, [onChange, sortBy, sortDir]);
    const handleMenuClick = useCallback((e) => {
        var _a;
        const targetOption = (_a = options.find((option) => option.key === e.key)) !== null && _a !== void 0 ? _a : options[0];
        updateFilter(targetOption);
    }, [options, updateFilter]);
    const sortOutlined = sortDir === SonarV3SortDirection.Ascending ?
        React.createElement(SortAscendingOutlined, { onClick: updateFilter.bind(this, {
                direction: SonarV3SortDirection.Descending,
                key: sortBy
            }) }) :
        React.createElement(SortDescendingOutlined, { onClick: updateFilter.bind(this, {
                direction: SonarV3SortDirection.Ascending,
                key: sortBy
            }) });
    return (React.createElement("div", { className: 'sort-by-filter' },
        React.createElement(Dropdown, { disabled: options.length <= 1, getPopupContainer: getDirectParent, menu: {
                items: options.map(({ disabled, disabledTooltip, key, label }) => ({
                    className: 'sort-by-filter-entry',
                    disabled,
                    key,
                    label: React.createElement(Tooltip, { open: disabled && disabledTooltip ? undefined : false, title: React.createElement(SanitizedHtml, { as: 'span', html: disabledTooltip !== null && disabledTooltip !== void 0 ? disabledTooltip : '' }) }, label)
                })),
                onClick: handleMenuClick
            } },
            React.createElement("div", { className: 'periscope-sort-by-text' },
                sortText,
                options.length > 1 && React.createElement(DownOutlined, null))),
        React.createElement(When, { condition: sortIcon },
            React.createElement("div", { className: 'sort-icon' }, sortOutlined))));
});
